<template>
  <PageLayout>
    <template v-slot:header>
      <div class="d-flex m-3 mx-lg-0">
        <Breadcrumb :list="breadcrumbList" />
      </div>
      <MainNavbar />
    </template>
    <template v-slot:main>
      <div>
        <b-card-group deck>
          <Slack
            :slack="slack"
            :loadingSlackConnect="loadingSlackConnect"
            :loadingSlack="loadingSlack"
            @deleteWorkspace="deleteWorkspace"
          />
          <b-card :title="labels.hangout.title" v-if="false">
            <b-card-text>{{ labels.hangout.text1 }}</b-card-text>
            <b-card-text>{{ labels.hangout.text2 }}</b-card-text>
            <template v-slot:footer>
              <b-button>{{ labels.hangout.soon }}</b-button>
            </template>
          </b-card>
        </b-card-group>
      </div>
      <modal-plans
        ref="component-modal-plans"
        :title="resources.general.menu.integrations"
        :hideHeaderClose="true"
        :visible="true"
        v-if="!$can('use', 'actionPlan')"
        @hide="handleHide"
      />
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayout from '@/components/Home/PageLayout.vue'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import Slack from '@/components/Integrations/Slack.vue'
import ModalPlans from '@/components/Modal/ModalPlans.vue'
import MainNavbar from '@/components/Management/MainNavbar'

export default {
  components: {
    Breadcrumb,
    PageLayout,
    Slack,
    ModalPlans,
    MainNavbar,
  },

  beforeCreate() {
    // connect slack
    const { code, state } = this.$route.query
    if (code && state === 'from-slack') {
      this.$router.replace({ query: {} })
      return this.$store.dispatch('integrations/connectSlack', { code })
    }
    // get slack integration
    this.$store.dispatch('integrations/getSlack')
  },

  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'integrations' })
  },

  computed: {
    breadcrumbList() {
      return [
        {
          label: this.resources.general.menu.settings,
        },
      ]
    },
    ...mapGetters({
      resources: 'resources',
      slack: 'integrations/slack',
      loadingSlackConnect: 'integrations/loadingSlackConnect',
      loadingSlack: 'integrations/loadingSlack',
    }),
    labels() {
      return this.resources.page.home.integrations
    },
  },

  methods: {
    handleHide() {
      this.$router.push({ name: 'dashboard' })
    },
    deleteWorkspace(workspace) {
      this.$store.dispatch('integrations/deleteSlack', workspace)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.card {
  margin: 10px;
}

.card-header {
  padding-right: 15px;
}
</style>
